<template>
  <div>
    <el-dialog
      title="选择定制单行项目"
      :visible="show"
      width="1000px"
      @close="close"
    >
      <el-table
        :data="itemList || []"
        stripe
        :row-key="
          (row) => {
            return row.id + row.lastEditTime;
          }
        "
        max-height="400px"
        v-loading="loading"
      >
        <el-table-column
          prop="commodityName"
          label="商品信息"
          min-width="200"
          align="left"
          header-align="center"
        >
          <template slot-scope="scope">
            <div style="line-height: 1.3em">
              <el-tooltip class="item" effect="dark" placement="top-start">
                <div slot="content" style="max-width: 300px">
                  <p>商品名称：{{ scope.row.commodityName }}</p>
                  <p class="fm-mt-5">
                    备注：
                    <span v-fmtype="scope.row.remark ? '' : 'warning'">{{
                      scope.row.remark || "——"
                    }}</span>
                  </p>
                </div>
                <div>
                  <p class="fm-line-2">
                    商品名称：{{ scope.row.commodityName }}
                  </p>
                  <p class="fm-line-2 fm-mt-5">
                    备注：
                    <span v-fmtype="scope.row.remark ? '' : 'warning'">{{
                      scope.row.remark || "——"
                    }}</span>
                  </p>
                </div>
              </el-tooltip>
            </div>
          </template>
        </el-table-column>

        <el-table-column
          label="相关图片"
          width="200"
          align="left"
          header-align="center"
        >
          <template slot-scope="scope">
            <div v-if="scope.row.fileList && scope.row.fileList.length > 0">
              <el-image
                v-for="(item, index) in scope.row.fileList"
                :key="index"
                :style="{
                  width: '45px',
                  height: '45px',
                  'border-radius': '5px',
                  border: '1px solid var(--fm-border-color)',
                  'margin-left': '5px',
                }"
                fit="cover"
                :preview-src-list="
                  scope.row.fileList.map(
                    (d) => d.sysFile.prefix + d.sysFile.name
                  )
                "
                :src="item.sysFile.prefix + item.sysFile.name"
              ></el-image>
            </div>
            <div class="fm-center" v-else>
              <p v-fmtype="'warning'">暂未上传</p>
            </div>
          </template>
        </el-table-column>
        <el-table-column
          prop="buyingPrice"
          label="商品零售价"
          width="100"
          align="center"
          header-align="center"
        >
          <template slot-scope="scope">
            <FmAmount :amount="scope.row.buyingPrice"></FmAmount>
          </template>
        </el-table-column>
        <el-table-column
          prop="itemQuantity"
          label="数量"
          width="100"
          align="center"
          header-align="center"
        >
          <template slot-scope="scope">
            {{ scope.row.itemQuantity + scope.row.unit }}
          </template>
        </el-table-column>
        <el-table-column
          prop="itemAmount"
          label="金额"
          width="150"
          align="left"
          header-align="center"
        >
          <template slot-scope="scope">
            <div style="line-height: 1.3em">
              <div class="fm-flex">
                总零售价：
                <FmAmount :amount="scope.row.buyingTotalAmount"></FmAmount>
              </div>
              <div class="fm-flex">
                折扣金额：<FmAmount
                  :amount="scope.row.buyingDisCountAmount"
                ></FmAmount>
              </div>
              <div class="fm-flex">
                成交价：<FmAmount
                  :amount="scope.row.itemBuyingAmount"
                ></FmAmount>
              </div>
            </div>
          </template>
        </el-table-column>
        <el-table-column
          prop="itemAmount"
          label="出入库进度"
          width="150"
          align="left"
          header-align="center"
        >
          <template slot-scope="scope">
            <div class="fm-flex">
              待入库：{{ scope.row.toBeInputQuantity }}，入库中：{{
                scope.row.inputingQuantity
              }}
            </div>
            <div class="fm-flex">
              已入库：{{ scope.row.completedInputQuantity }}，待出库：{{
                scope.row.toBeOutputQuantity
              }}
            </div>
            <div class="fm-flex">
              出库中：{{ scope.row.outputingQuantity }}，已出库：{{
                scope.row.completedOutputQuantity
              }}
            </div>
          </template>
        </el-table-column>
        <el-table-column
          prop="extFieldValueList"
          label="拓展字段"
          width="150"
          align="left"
          header-align="center"
        >
          <template slot-scope="scope">
            <div
              v-if="
                scope.row.extFieldValueList &&
                scope.row.extFieldValueList.length > 0
              "
            >
              <div
                v-for="(item, index) in scope.row.extFieldValueList"
                :key="index"
              >
                {{
                  item.label +
                  "：" +
                  (item.value == null ? "-" : item.value) +
                  ";"
                }}
              </div>
            </div>
            <div class="fm-center" v-else>—</div>
          </template>
        </el-table-column>
        <el-table-column
          fixed="right"
          label="操作"
          header-align="center"
          align="center"
          width="120"
        >
          <template slot-scope="scope">
            <el-button
              @click.native.stop="select(scope.row)"
              type="text"
              icon="el-icon-document"
            >
              选择
            </el-button>
          </template>
        </el-table-column>
      </el-table>
    </el-dialog>

    <el-dialog
      title="选择定制单行项目"
      :visible="editItemPopupShow"
      width="600px"
      @close="editItemPopupShow = false"
      v-if="editItemPopupShow"
    >
      <p>商品：{{ editItem.relatedCustomizeOrderItem.commodityName }}</p>
      <p>备注：{{ editItem.relatedCustomizeOrderItem.remark }}</p>
      <el-divider></el-divider>
      <el-form ref="form" :model="editItem" label-width="100px">
        <el-row>
          <el-col :span="12">
            <el-form-item style="margin-bottom: 0" label="零售单价">
              <FmAmount
                :amount="editItem.relatedCustomizeOrderItem.buyingPrice"
              ></FmAmount>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item style="margin-bottom: 0" label="销售数量">
              {{
                editItem.relatedCustomizeOrderItem.itemQuantity +
                " " +
                editItem.relatedCustomizeOrderItem.unit
              }}
            </el-form-item>
          </el-col>
        </el-row>
        <el-form-item label="出入库进度">
          <div style="line-height: 1.3em; padding: 7px 0">
            <p class="fm-flex">
              待入库
              {{ editItem.relatedCustomizeOrderItem.toBeInputQuantity }}，入库中
              {{ editItem.relatedCustomizeOrderItem.inputingQuantity }}
            </p>
            <p class="fm-flex">
              已入库
              {{
                editItem.relatedCustomizeOrderItem.completedInputQuantity
              }}，待出库
              {{ editItem.relatedCustomizeOrderItem.toBeOutputQuantity }}
            </p>
            <p class="fm-flex">
              出库中
              {{ editItem.relatedCustomizeOrderItem.outputingQuantity }}，已出库
              {{ editItem.relatedCustomizeOrderItem.completedOutputQuantity }}
            </p>
          </div>
        </el-form-item>
        <template v-if="from == 'CustomizePurchaseOrder'">
          <el-divider></el-divider>
          <el-form-item label="采购价" prop="retailPrice">
            <el-input-number
              style="width: 200px"
              v-model="editItem.retailPrice"
              :precision="2"
              :min="0"
              :step="1"
              @change="changeItemPrice"
            ></el-input-number>
          </el-form-item>
          <el-form-item label="采购数量" prop="itemQuantity">
            <CommodityQuantityInputBox
              style="width: 200px"
              :key="'itemQuantityInputNumber' + itemQuantityKey"
              :value="editItem.itemQuantity"
              size="mini"
              :max="editItem.relatedCustomizeOrderItem.toBeInputQuantity"
              @change="
                (e) => {
                  changeItemQuantity(e);
                }
              "
            ></CommodityQuantityInputBox>
          </el-form-item>
          <el-form-item label="总采购价" prop="commodityRetailTotalAmount">
            <FmAmount :amount="editItem.commodityRetailTotalAmount"></FmAmount>
          </el-form-item>
          <el-form-item label="折扣金额" prop="disCountAmount">
            <FmAmount :amount="editItem.disCountAmount"></FmAmount>
          </el-form-item>
          <el-form-item label="成交价" prop="itemAmount">
            <el-input-number
              style="width: 200px"
              v-model="editItem.itemAmount"
              size="mini"
              :precision="2"
              :min="0"
              :max="
                typeof editItem.commodityRetailTotalAmount == 'string'
                  ? Number(editItem.commodityRetailTotalAmount)
                  : editItem.commodityRetailTotalAmount
              "
              :step="1"
              @change="changeItemAmount(editItem)"
            ></el-input-number>
          </el-form-item>
        </template>

        <template v-if="from == 'CustomizeOutputOrder'">
          <el-divider></el-divider>
          <el-form-item label="出库数量" prop="itemQuantity">
            <CommodityQuantityInputBox
              style="width: 200px"
              :key="'itemQuantityInputNumber' + itemQuantityKey"
              label="数量"
              :value="editItem.itemQuantity"
              size="mini"
              :max="editItem.relatedCustomizeOrderItem.toBeOutputQuantity"
              @change="
                (e) => {
                  changeItemQuantity(e);
                }
              "
            ></CommodityQuantityInputBox>
          </el-form-item>
        </template>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="editItemCancel">取 消</el-button>
        <el-button type="primary" @click="editItemConfirm">选 择</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: "Fmerpv2WebCustomizeOrderItemSelectDialog",
  props: {
    show: {
      type: Boolean,
      default: false,
    },
    from: {
      // 来源，CustomizePurchaseOrder 定制采购单 | CustomizeOutputOrder 定制出库单
      type: String,
      default: null,
      require: true,
    },
    customizeOrderId: {
      type: String,
      default: null,
      require: true,
    },
    selectList: {
      type: Array,
      default: () => {
        return [];
      },
    },
  },
  watch: {
    show: {
      handler(newVal) {
        this.getOrderInfo();
        this.quantityMinLimit = this.$jsTool.getTenantDecimalLength();
      },
      immediate: true,
    },
  },
  data() {
    return {
      loading: false,

      editItemPopupShow: false,
      // 当前选择的item
      editItem: {},

      // 显示已选商品弹窗
      showSelectListPopup: false,

      itemQuantityKey: "null",
      itemList: [],

      quantityMinLimit: 0.001,
    };
  },

  mounted() {},

  methods: {
    close() {
      this.$emit("close");
    },

    select(item) {
      // CustomizePurchaseOrder 定制采购单 | CustomizeOutputOrder 定制出库单
      if (this.from == "CustomizePurchaseOrder") {
        if (item.toBeInputQuantity <= 0) {
          this.$message({
            message: "所选定制单行项目待入库数量为 0 ，请选择其他行项目",
            type: "error",
          });
          return;
        }
      } else if (this.from == "CustomizeOutputOrder") {
        if (item.toBeOutputQuantity <= 0) {
          this.$message({
            message: "所选定制单行项目待出库数量为 0 ，请选择其他行项目",
            type: "error",
          });
          return;
        }
      }

      let index = this.selectList.findIndex(
        (d) => d.relatedOrderItemId == item.id
      );
      if (index > -1) {
        this.editItem = JSON.parse(JSON.stringify(this.selectList[index]));
        if (this.from == "CustomizeOutputOrder") {
          if (this.selectList[index].distributionPrice) {
            this.editItem.distributionPrice =
              this.selectList[index].distributionPrice;
          } else {
            this.editItem.distributionPrice = "0.00";
          }
        }
      } else {
        let itemNo =
          this.selectList && this.selectList.length > 0
            ? this.selectList[this.selectList.length - 1].itemNo + 1
            : 1;
        this.editItem = {
          itemNo: itemNo,
          relatedOrderItemId: item.id,
          relatedCustomizeOrderItem: item,
          retailPrice: "0.00",
          itemQuantity: 1,
          commodityRetailTotalAmount: "0.00",
          disCountAmount: "0.00",
          itemAmount: "0.00",
          distributionPrice: "0.00",
        };
      }
      this.editItemPopupShow = true;
    },
    editItemCancel() {
      this.editItemPopupShow = false;
      this.editItem = {};
    },

    changeItemPrice() {
      if (!this.editItem.retailPrice) {
        this.editItem.retailPrice = "0.00";
      }
      let itemAmount = this.$jsTool.multi(
        this.editItem.retailPrice,
        this.editItem.itemQuantity
      );
      this.editItem = {
        ...this.editItem,
        commodityRetailTotalAmount: itemAmount,
        disCountAmount: 0,
        itemAmount: itemAmount,
      };
    },
    changeItemQuantity(value) {
      if (!value) {
        value = 0;
      }
      if (value <= 0) {
        this.$confirm("是否移除所选商品?", "操作提醒", {
          confirmButtonText: "移除",
          cancelButtonText: "取消",
          type: "warning",
          closeOnClickModal: false,
          closeOnPressEscape: false,
          closeOnHashChange: false,
        })
          .then(() => {
            this.selectList.splice(index, 1);
          })
          .catch(() => {
            this.editItem.itemQuantity = 1;
            this.itemQuantityKey = Math.random();
          });
      } else {
        let retailTotalAmount = this.$jsTool.multi(
          this.editItem.retailPrice,
          value
        );
        this.editItem = {
          ...this.editItem,
          itemQuantity: value,
          commodityRetailTotalAmount: retailTotalAmount,
          disCountAmount: 0,
          itemAmount: retailTotalAmount,
        };
      }
    },
    changeItemAmount() {
      if (
        (!this.editItem.retailPrice ||
          Number(this.editItem.retailPrice) == 0) &&
        (!this.editItem.commodityRetailTotalAmount ||
          Number(this.editItem.commodityRetailTotalAmount) == 0)
      ) {
        this.editItem.disCountAmount = "0.00";
      } else {
        this.editItem.disCountAmount = this.$jsTool.sub(
          this.editItem.commodityRetailTotalAmount,
          this.editItem.itemAmount
        );
      }
    },

    editItemConfirm() {
      if (!this.editItem || !this.editItem.itemNo) {
        this.$message({
          message: "请选择商品",
          type: "error",
        });
        return;
      }
      if (!this.editItem.itemQuantity) {
        this.$message({
          message: "请输入数量",
          type: "error",
        });
        return;
      }
      this.loading = true;
      try {
        let index = this.selectList.findIndex(
          (d) => d.relatedOrderItemId == this.editItem.relatedOrderItemId
        );
        if (this.from == "CustomizeOutputOrder") {
          if (
            this.editItem.itemQuantity >
            this.editItem.relatedCustomizeOrderItem.toBeOutputQuantity
          ) {
            this.$message({
              message:
                "出库数量不得大于所选商品的待出库数量" +
                this.editItem.relatedCustomizeOrderItem.toBeOutputQuantity,
              type: "error",
            });
            return;
          }
        }
        if (this.from == "CustomizePurchaseOrder") {
          if (
            this.editItem.itemQuantity >
            this.editItem.relatedCustomizeOrderItem.toBeInputQuantity
          ) {
            this.$message({
              message:
                "采购数量不得大于所选商品的待入库数量" +
                this.editItem.relatedCustomizeOrderItem.toBeInputQuantity,
              type: "error",
            });
            return;
          }
        }
        if (index > -1) {
          this.selectList.splice(index, 1, this.editItem);
        } else {
          this.selectList.push(this.editItem);
        }
        this.editItemPopupShow = false;
        this.$emit("selectCustomizeOrderItem", this.selectList || []);
      } finally {
        setTimeout(() => {
          this.loading = false;
        }, 200);
        if (!this.editItemPopupShow) {
          this.$emit("close");
        }
      }
    },

    changeItemQuantityFromList(value, index) {
      if (this.from == "CustomizeOutputOrder") {
        this.editItem.distributionPrice = "0.00";
      }
      // 如果index < 0，则代表是新商品，无需进行处理
      if (index < 0) {
        return;
      }
      if (value <= 0) {
        this.$confirm("是否移除所选商品?", "操作提醒", {
          confirmButtonText: "移除",
          type: "warning",
          closeOnClickModal: false,
          closeOnPressEscape: false,
          closeOnHashChange: false,
        })
          .then(() => {
            try {
              this.editItem = {};
              this.selectList.splice(index, 1);
              this.editItemPopupShow = false;
              this.$emit("selectCustomizeOrderItem", this.selectList || []);
            } finally {
              if (!this.editItemPopupShow) {
                this.$emit("close");
              }
            }
          })
          .catch(() => {
            this.editItem.itemQuantity = this.quantityMinLimit;
          });
      }
    },

    async getOrderInfo(args) {
      this.loading = true;
      let res = await this.$api.customizeOrder_findVoById(
        this.customizeOrderId,
        args
      );
      if (res && res.success) {
        this.itemList = res.data.itemList;
      }
      setTimeout(() => {
        this.loading = false;
      }, 200);
    },
  },
};
</script>

<style scoped>
/* 解决分割线存在粗细不一致异常 */
.el-divider {
  background-color: transparent;
  position: relative;
}

.el-divider--horizontal {
  height: 0;
  border-bottom: 1px solid #dcdfe6;
}
</style>


// WEBPACK FOOTER //
// src/components/CustomizeOrderItemSelectDialog.vue